import ScrollReveal from "./ScrollReveal";

const About = () => {

  // Updated URL provided by the user
  // Note: I've included both the MP4 and a placeholder for a WebM version for optimal cross-browser performance.
  const videoMp4Url = "https://siekuhdkqiuwncigwrah.supabase.co/storage/v1/object/public/site-assets/atc.mp4";
  const videoWebmUrl = "https://siekuhdkqiuwncigwrah.supabase.co/storage/v1/object/public/site-assets/atc.webm";

  return (
    <section id="about" className="py-24 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        
        {/* Header - H2 level is correct following the Hero section */}
        <ScrollReveal>
          <h1 className="text-3xl sm:text-4xl font-bold text-foreground mb-12 text-center">
            About Us
          </h1>
        </ScrollReveal>
        
        {/* Video Section with performance optimizations */}
          <ScrollReveal delay={0.1}>
            <div className="relative w-full max-w-4xl mx-auto mb-16 aspect-video rounded-2xl overflow-hidden shadow-2xl border border-border bg-black">
              <div className="w-full h-full rounded-xl overflow-hidden bg-black flex items-center justify-center">
                <video 
                autoPlay
                  className="w-full h-full object-cover"
                  controls 
                  muted
                  playsInline
                  preload="metadata" // IMPORTANT: Prevents downloading the full file on load
                  poster="/ac-logo.webp" // Displays logo immediately to improve First Contentful Paint
                >
                  {/* WebM version (smaller file size) should be first if available */}
                  <source src={videoWebmUrl} type="video/webm" />
                  <source src={videoMp4Url} type="video/mp4" />
                  <track kind="captions" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <h3 className="text-muted-foreground text-lg leading-relaxed max-w-4xl mx-auto text-center font-normal">
            Automated Transaction Coordinator (ATC) is a comprehensive full service Transaction Coordinating service provider, designed to revolutionize your real estate transaction process by significantly saving you time, reducing costs, and alleviating stress. ATC transcends the ordinary bounds of transaction coordination by meticulously managing all documentation related to a real estate transaction, from the initial contract to the final close. Our services extend to managing all aspects of E-signatures, delivering addendums, buyer/seller required forms, Seller Disclosures, and related documents. We communicate and coordinate with all parties (the cooperating agent, title, lender, inspector, etc). We also provide timely reminders and communication regarding deadlines and tasks. Moreover, ATC actively coordinates with your clients, explaining necessary documents for e-signing, providing a moving checklist & reminders to help them stay on schedule as well. All the while enhancing your professional image, building a long lasting relationship with your clients.
          </h3>
        </ScrollReveal>

      </div>
    </section>
  );
};

export default About;